<template>
  <div v-if="show" class="upload-candidate" :class="{ uploading }">
    <template v-if="showThirdParty">
      <div class="third-party header-container">
        {{ $t(`${thirdPartyI18nPrefix}.label.importResume`) }}
      </div>
      <div class="third-party-container">
        <div
          v-for="(channel, index) in thirdPartyChannel"
          v-auto-tooltip.always="{ content: $t(`${thirdPartyI18nPrefix}.label.import`) }"
          class="channel-container"
          :key='index'
          :class="'channel-' + channel.name"
        >
          <div class="channel-icon" @click="handelImport(channel)">
            <i v-if="channel.name === '51job'" class="iconfont icona-51Job"></i>
            <i v-else-if="channel.name === 'linkedin'" class="iconfont iconLinkedin"></i>
            <i v-else-if="channel.name === 'jobstreet'" class="iconfont iconGongzuojie"></i>
          </div>
          <!-- <div class="import-container" @click="handelImport(channel)">
            <div class="import-btn">
              {{ $t(`${thirdPartyI18nPrefix}.label.import`) }}
            </div>
          </div> -->
        </div>
      </div>
      <div class="split-line" v-if="showThirdParty">
        <div class="line"></div>
        <div class="content">{{ $t('common.separator.or') }}</div>
        <div class="line"></div>
      </div>
      <div class="upload-resume header-container">
        {{ $t(`${thirdPartyI18nPrefix}.label.uploadResume`) }}
      </div>
      <el-dialog
        :title="$t(`${thirdPartyI18nPrefix}.label.importResume`)"
        :visible.sync="dialogSetting.show"
        :close-on-click-modal="false"
      >
        <template v-if="showSelectResume">
          <div class="select-resume-container">
            <div class="select-resume-item">
              <span class="title">{{ $t(`${thirdPartyI18nPrefix}.label.resumeName`) }}</span>
              <el-select class="content" aria-required="true" v-model="importResumeSelectFrom.selectUrl" :placeholder="$t(`${thirdPartyI18nPrefix}.placeholder.resume`)">
                <el-option
                  v-for="(item, index) in importResumeList"
                  :key="index"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="btn-container">
              <el-button
                class="action-btn cancel-btn"
                @click="handelCancelThirdParty"
              >
                {{ $t(`${thirdPartyI18nPrefix}.btn.cancel`) }}
              </el-button>
              <el-button
                class="action-btn login-btn"
                @click="handelImportResume"
              >
                {{ $t(`${thirdPartyI18nPrefix}.btn.import`) }}
              </el-button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="third-party-form-container">
              <div class="form-container">
                <div class="item-container type-container">
                  <span class="title type">{{ $t(`${thirdPartyI18nPrefix}.label.signInWith`) }}</span>
                  <el-select
                    class="content"
                    v-model="thirdPartyForm.thirdparty"
                    :placeholder="$t(`${thirdPartyI18nPrefix}.placeholder.platform`)"
                    @change="handelThirdpartyChannelChange"
                  >
                    <el-option
                      v-for="item in thirdPartySelect"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type"
                      >
                      <span class="channel-option-span" :class="item.className">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                </div>
                <div class="item-container user-container">
                  <span class="title username">{{ $t(`${thirdPartyI18nPrefix}.label.thirdPartyAccount`) }}</span>
                  <el-input class="content" :placeholder="$t(`${thirdPartyI18nPrefix}.placeholder.account`)" v-model="thirdPartyForm.username"></el-input>
                </div>
                <div class="item-container password-container">
                  <span class="title password">{{ $t(`${thirdPartyI18nPrefix}.label.thirdPartyPassword`) }}</span>
                  <el-input class="content" :placeholder="$t(`${thirdPartyI18nPrefix}.placeholder.password`)" v-model="thirdPartyForm.userpwd" show-password></el-input>
                </div>
              </div>
              <div class="btn-container">
                <el-button
                  class="action-btn cancel-btn"
                  @click="handelCancelThirdParty"
                >
                  {{ $t(`${thirdPartyI18nPrefix}.btn.cancel`) }}
                </el-button>
                <el-button
                  class="action-btn login-btn"
                  :disabled="!canThirdPartyLogin"
                  @click="handelThirdParty"
                >
                  {{ $t(`${thirdPartyI18nPrefix}.btn.signIn`) }}
                </el-button>
              </div>
              <RectLoading v-show="showThirdPartyLoading"/>
          </div>
        </template>
      </el-dialog>
    </template>
    <div class="container-line file-selector-container">
      <div class="container-content" :class="showUploadResumeTips && 'required-class'">
        <div class="upload-dragger" @dragover.prevent="handleDragOver" @drop.prevent="handleDrop">
          <div class="upload-icon">
            <i class="upload iconfont" :class="showReupload ? 'icona-MyProfile blue-icon' : 'iconupload'"></i>
          </div>
          <div class="drop-tip" v-show="!showReupload">{{ $t(`${i18nPrefix}.message.dropTip`) }}</div>
          <div class="or-tip" v-show="!showReupload">{{ $t('common.separator.or') }}</div>
          <div class="original-file-name" v-show="showReupload">{{ originalFileName }}</div>
          <div class="browser-file">
            <label :for="uploading || 'browserFiles'" class="browser-file-label" :class="showReupload && 'reupload'">{{ $t(`${i18nPrefix}.label.${showReupload ? 'reupload' : 'browserFiles'}`) }}</label>
            <input
              id="browserFiles"
              ref="browserFilesInput"
              type="file"
              multiple="multiple"
              class="browser-file-input"
              :accept="inputAcceptFileType"
              @change="handleBrowserFilesChange"
            />
          </div>
          <!-- <div class="upload-tip">{{ $t(`${i18nPrefix}.message.uploadTip`) }}</div> -->
        </div>
        <div class="upload-tip">
          <div v-for="(item, index) in $t(`${i18nPrefix}.message.uploadTips`)" class="tip-block" :key="index">{{ item }}</div>
        </div>
      </div>
      <div class="upload-tips" v-if="needUploadResume && showUploadResumeTips">
        {{ $t('common.message.requiredFormField') }}
      </div>
    </div>
    <div v-if="!uploading && currentFile" class="container-line file-list-container" >
      <div class="container-title">{{ $t(`${i18nPrefix}.containerTitle.selectedFiles`) }}</div>
      <div class="container-content">
        <div class="file">
          <div class="file-icon"></div>
          <div class="file-name" >{{ currentFile.name }}</div>
          <div class="remove-btn" @click="handleDeleteFile">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div v-if="!onlyUploadResume" class="upload-btn-container adapt-wrapper">
          <el-button class="upload-btn orange-btn" @click="handUploadBtnClick">{{ $t(`${i18nPrefix}.btn.startUpload`) }}</el-button>
        </div>
      </div>
    </div>
    <div v-else-if="uploading" class="container-line upload-task-container">
      <div class="container-title">{{ $t(`${i18nPrefix}.containerTitle.uploadStatus`) }}</div>
      <div class="container-content">
        <div class="upload-task">
          <div class="file-icon"></div>
          <div class="file-name" >{{ currentFile.name }}</div>
          <div class="upload-progress" :style="{ width: `${uploadTask.percentage}%` }"></div>
        </div>
      </div>
    </div>
    <RectLoading v-show="loading" class="loading"/>
    <template v-if="showCreateNewBtn || isCandidateEditMode || (!isHrEditResume && !isAgencyEditResume && !needUploadResume && !onlyUploadResume)">
      <div class="split-line">
        <div class="line"></div>
        <div class="content">{{ $t('common.separator.or') }}</div>
        <div class="line"></div>
      </div>
      <div class="create-new-resume-container">
        <el-button class="create-btn" @click="createNewResume">{{ $t(`${i18nPrefix}.btn.${existResume ? 'editProfile' : 'createNewResume'}`)}}</el-button>
      </div>
    </template>
    <AIResumeParseLoadingDialog
      :isShow="showAIResumeParseDialog"
    />
  </div>
</template>

<script>

import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import mixin from './mixin'
import RectLoading from '@/components/loading/rectLoading'
import {
  THIRD_PARTY_CHANNEL_TYPE_51, THIRD_PARTY_CHANNEL_TYPE_FACEBOOK,
  THIRD_PARTY_CHANNEL_TYPE_LINKEDIN, THIRD_PARTY_CHANNEL_TYPE_JOBSTREET,
  THIRD_PARTY_LOGIN_STATUS_MAPPING
} from '@/constant/thirdParty'
import { generateTempFileKey, getFileExtension, uploadFile } from '@/utils/oss'
import AIResumeParseLoadingDialog from '@/components/dialog/aiResumeParseLoadingDialog.vue'
import { AI_PARSE_MAX_COUNT, MAX_UPLOAD_RESUME_FILE_SIZE } from '@/constant/application'

export default {
  mixins: [mixin],
  components: {
    AIResumeParseLoadingDialog,
    RectLoading
  },
  props: {
    setting: {
      type: Object,
      required: false
    },
    isHrEditResume: {
      type: Boolean,
      default: false
    },
    isCandidate: {
      type: Boolean,
      default: false
    },
    existResume: {
      default: false
    },
    isAgencyEditResume: {
      type: Boolean,
      default: false
    },
    companyId: {
      required: false
    }
  },
  data () {
    return {
      THIRD_PARTY_CHANNEL_TYPE_51,
      THIRD_PARTY_CHANNEL_TYPE_FACEBOOK,
      THIRD_PARTY_CHANNEL_TYPE_LINKEDIN,
      THIRD_PARTY_CHANNEL_TYPE_JOBSTREET,
      thirdPartyI18nPrefix: 'thirdParty',
      i18nPrefix: 'admin.application.candidate',
      hasForm: false,
      acceptFileTypes: [
        'text/html',
        'application/pdf',
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/bmp'
      ],
      currentFile: null,
      uploadTask: {
        taskId: null,
        finished: false,
        percentage: 0
      },
      uploading: false,
      dialogSetting: {
        show: false
      },
      canThirdPartyLogin: true,
      showThirdPartyLoading: false,
      thirdPartyForm: {
        thirdparty: THIRD_PARTY_CHANNEL_TYPE_51,
        username: '',
        userpwd: '',
        login_verify: ''
      },
      thirdPartyTask: {
        thirdparty: '',
        taskId: null,
        status: '',
        times: 0
      },
      importResumeSelectFrom: {
        resumeList: [],
        selectUrl: null
      },
      authUrl: {
        linkedinAuthUrl: ''
      },
      showUploadResumeTips: false,
      uploadedResume: false,
      showAIResumeParseDialog: false,
      parseCount: 1
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount', 'isCompanyAccount', 'isCandidateAccount', 'isHeadhunterAccount']),
    ...mapGetters('company', ['companyThemeSetting']),
    currentAccount () {
      return this.getCurrentAccount
    },
    isCandidateEditMode () {
      return this.isEditMode && this.isCandidate
    },
    useAIResumeParse () {
      const hasAIResumeParsePermission = this.hasAnyPermission('PREMIUM_AI_RESUME_PARSE')
      if (this.isCompanyAccount && hasAIResumeParsePermission) {
        return true
      } else if (this.isHeadhunterAccount && this.setting?.hasAIResumeParsePermission) {
        return true
      } else if (this.isCandidateAccount && this.companyThemeSetting?.company.has_ai_resume_parse_premium) {
        return true
      }
      return false
    },
    thirdPartyChannel () {
      const list = [
        {
          name: '51job',
          cnName: '前程无忧',
          type: THIRD_PARTY_CHANNEL_TYPE_51
        },
        // {
        //   name: 'facebook',
        //   cnName: 'Facebook',
        //   type: THIRD_PARTY_CHANNEL_TYPE_FACEBOOK
        // },
        {
          name: 'linkedin',
          cnName: 'LinkedIn',
          type: THIRD_PARTY_CHANNEL_TYPE_LINKEDIN,
          hidden: this.onlyUploadResume
        },
        {
          name: 'jobstreet',
          cnName: '求职工作街',
          type: THIRD_PARTY_CHANNEL_TYPE_JOBSTREET,
          hidden: false
        }
      ]
      return _.filter(list, item => !item.hidden)
    },
    thirdPartySelect () {
      const list = [
        {
          name: '51job',
          cnName: '前程无忧',
          className: 'channel-51job',
          type: THIRD_PARTY_CHANNEL_TYPE_51,
          hidden: false
        },
        {
          name: 'jobstreet',
          cnName: '求职工作街',
          className: 'jobstreet',
          type: THIRD_PARTY_CHANNEL_TYPE_JOBSTREET,
          hidden: false
        }
      ]
      return _.filter(list, item => !item.hidden)
    },
    inputAcceptFileType () {
      return this.acceptFileTypes.join(',')
    },
    showThirdParty () {
      if (this.setting?.showThirdParty) {
        return true
      }
      return false
    },
    showSelectResume () {
      if (this.importResumeSelectFrom.resumeList.length > 0) {
        return true
      }
      return false
    },
    importResumeList () {
      const list = []
      const resumeFrom = this.importResumeSelectFrom.resumeList || []
      const cnName = this.$t(`${this.thirdPartyI18nPrefix}.label.resumeCnName`)
      const enName = this.$t(`${this.thirdPartyI18nPrefix}.label.resumeEnName`)
      _.forEach(resumeFrom, (item) => {
        if (item.cn_resume_url === item.en_resume_url) {
          list.push({
            name: item.resume_name,
            value: item.cn_resume_url
          })
        } else {
          if (item.cn_resume_url) {
            list.push({
              name: item.resume_name + cnName,
              value: item.cn_resume_url
            })
          }
          if (item.en_resume_url) {
            list.push({
              name: item.resume_name + enName,
              value: item.en_resume_url
            })
          }
        }
      })
      return list
    },
    showReupload () {
      if ((this.isHrEditResume || this.isAgencyEditResume) && this.originalFileName) {
        return true
      }
      return false
    },
    originalFileName () {
      let fileName = ''
      if (this.candidateInfo?.baseInfo?.originalFileType) {
        fileName = 'xxxxx' + this.candidateInfo.baseInfo.originalFileType
      }
      return fileName
    },
    needUploadResume () {
      if (this.setting?.needUploadResume) {
        return true
      }
      return false
    },
    onlyUploadResume () {
      if (this.setting?.onlyUploadResume) {
        return true
      }
      return false
    },
    showCreateNewBtn () {
      return this.setting?.showCreateNewBtn
    },
    immediateUpload () {
      return this.setting?.immediateUpload
    }
  },
  created () {
    this.$eventBus.$off('showAIResumeParseDialog')
    this.$eventBus.$on('showAIResumeParseDialog', (show) => {
      this.showAIResumeParseDialog = show
    })
    if (this.showThirdParty) {
      this.initThirdPartyLoginUrl()
    }
  },
  mounted () {

  },
  beforeDestroy () {
    this.$eventBus.$off('showAIResumeParseDialog')
  },
  methods: {
    ...mapActions('application', [
      'parseCandidateResumeByHR',
      'createParseResumeInfoByHRTask',
      'getParseResumeInfoByHRTaskStatus'
    ]),
    ...mapActions('personal', [
      'getResumeFromThirdParty',
      'checkLoginStatusForThirdParty',
      'parseResumeFromThirdParty',
      'getUrlToImportThirdPartyResume',
      'parseCandidateResumeByCandidate',
      'createParseResumeInfoByCandidateTask',
      'getParseResumeInfoByCandidateTaskStatus'
    ]),
    async initThirdPartyLoginUrl () {
      const resp = await this.getUrlToImportThirdPartyResume({ apply_job_id: this.isCandidate ? this.jobId : undefined })
      if (resp && resp.linkedin_auth_url) {
        this.authUrl.linkedinAuthUrl = resp.linkedin_auth_url
      }
    },
    handleDragOver ($event) {

    },
    handleDrop ($event) {
      this.addSelectFile($event.dataTransfer?.files)
    },
    handleBrowserFilesChange ($event) {
      this.addSelectFile($event.target?.files)
    },
    handleDeleteFile () {
      this.currentFile = null
    },
    addSelectFile (files) {
      if (!files || this.uploading) {
        return
      }
      const file = files[0]
      if (file.size > MAX_UPLOAD_RESUME_FILE_SIZE) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.fileSizeLimit`, { size: 10 }))
        return
      }
      this.currentFile = file
      this.showUploadResumeTips = false
      if (this.onlyUploadResume && this.immediateUpload) {
        this.$emit('save')
      }
    },
    async handUploadBtnClick () {
      let jobId = null
      const fileExt = getFileExtension(this.currentFile)
      const fileKey = generateTempFileKey(fileExt)
      if (this.isCandidate && this.jobId && this.jobId !== '-1') {
        jobId = this.jobId
      } else {
        const tempJobId = this.$route.params.jobId
        if (tempJobId && tempJobId !== '-1') {
          jobId = tempJobId
        }
      }
      const uploadTask = this.uploadTask = {
        taskId: null,
        finished: false,
        percentage: 0
      }
      this.uploading = true
      try {
        await uploadFile(this.currentFile, fileKey)
        uploadTask.percentage = 100
        if (this.useAIResumeParse) {
          this.showAIResumeParseDialog = true
        } else {
          this.$eventBus.$emit('showLoading', true)
        }
        const resumeInfo = await this.parseResume(fileKey, jobId)
        if (resumeInfo) {
          this.uploading = false
          this.uploadedResume = true
          this.$emit('change', resumeInfo)
          this.hasChangedData = false
          this.currentFile = null
          this.$refs.browserFilesInput.value = null
        }
      } finally {
        this.uploading = false
        if (this.useAIResumeParse) {
          this.showAIResumeParseDialog = false
        } else {
          this.$eventBus.$emit('showLoading', false)
        }
      }
    },
    async parseResume (fileKey, jobId) {
      let createParseResumeInfoTask = this.createParseResumeInfoByHRTask
      if (this.isCandidate) {
        createParseResumeInfoTask = this.createParseResumeInfoByCandidateTask
      }
      const resp = await createParseResumeInfoTask({ resume_file: fileKey, job_id: jobId, company_id: this.companyId })
      if (resp) {
        const taskId = resp.task_id
        this.parseCount = 1
        const resumeInfo = await this.getParseResumeInfo(taskId)
        return resumeInfo
      }
    },
    async getParseResumeInfo (taskId) {
      if (this.parseCount > AI_PARSE_MAX_COUNT) {
        this.$message.error(this.$t(`${this.i18nPrefix}.message.aiParseResumeTimeout`))
        return
      }
      let getParseResumeInfoTaskStatus = this.getParseResumeInfoByHRTaskStatus
      if (this.isCandidate) {
        getParseResumeInfoTaskStatus = this.getParseResumeInfoByCandidateTaskStatus
      }
      const resp = await getParseResumeInfoTaskStatus({ task_id: taskId })
      if (resp) {
        const status = resp.status
        if (status === 'PENDING') {
          return new Promise((resolve) => {
            setTimeout(async () => {
              const result = await this.getParseResumeInfo(taskId)
              resolve(result)
            }, 1000)
          })
        } else if (status === 'SUCCESS') {
          return resp.result
        } else {
          if (this.useAIResumeParse) {
            this.$message.error(this.$t(`${this.i18nPrefix}.message.aiParseResumeError`))
          } else {
            this.$message.error(this.$t(`${this.i18nPrefix}.message.parseResumeError`))
          }
        }
      }
    },
    customValidate () {
      if (this.onlyUploadResume && this.currentFile) {
        return true
      }
      if (this.needUploadResume && !this.uploadedResume) {
        this.showUploadResumeTips = true
        return false
      }
      return !this.uploading
    },
    handelImport (channel) {
      if (channel.type === THIRD_PARTY_CHANNEL_TYPE_LINKEDIN) {
        window.location.href = this.authUrl.linkedinAuthUrl
        return
      }
      this.dialogSetting.show = true
      if (![THIRD_PARTY_CHANNEL_TYPE_51, THIRD_PARTY_CHANNEL_TYPE_JOBSTREET].includes(channel.type)) {
        return
      }
      if (this.thirdPartyForm.thirdparty !== channel.type) {
        this.cleanThirdPartyStatusLoginStatus()
      }
      this.thirdPartyForm.thirdparty = channel.type
    },
    handelCancelThirdParty () {
      this.dialogSetting.show = false
    },
    async handelThirdParty () {
      this.canThirdPartyLogin = false
      this.showThirdPartyLoading = true
      const resp = await this.getResumeFromThirdParty(this.thirdPartyForm)
      if (resp && resp.data) {
        if (resp.status === 'status') {
          this.thirdPartyTask.taskId = resp.data
          this.thirdPartyTask.status = resp.status
          this.thirdPartyTask.thirdparty = this.thirdPartyForm.thirdparty
          this.checkThirdPartyStatus()
        } else if (resp.status === 'failed' && resp.data?.errmsg) {
          if (THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg]) {
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.${THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg].i18nKey}`))
          } else {
            this.$message.error(this.$t(`${this.i18nPrefix}.message.thirdPartyLoginError`))
          }
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        } else {
          this.$message.error(this.$t(`${this.i18nPrefix}.message.thirdPartyLoginError`))
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        }
      }
    },
    async handelImportResume () {
      const params = {
        thirdparty: this.thirdPartyForm.thirdparty,
        resume_url: this.importResumeSelectFrom.selectUrl,
        job_id: this.jobId,
        company_id: this.companyId
      }
      if (this.useAIResumeParse) {
        this.showAIResumeParseDialog = true
      }
      try {
        const resp = await this.parseResumeFromThirdParty(params)
        if (resp) {
          if (resp.status === 'success') {
            const resumeData = resp.resume_data
            if (this.onlyUploadResume) {
              this.$emit('uploadResume', resumeData)
              this.dialogSetting.show = false
              return
            }
            this.uploadedResume = true
            this.showUploadResumeTips = false
            this.$emit('change', resumeData)
            this.dialogSetting.show = false
          } else if (resp.status === 'failure') {
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.praseFailure`))
          } else if (resp.status === 'expiration') {
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.loginExpiration`))
            this.cleanThirdPartyStatusLoginStatus()
            this.dialogSetting.show = false
          }
        }
      } finally {
        this.showAIResumeParseDialog = false
      }
    },
    async checkThirdPartyStatus () {
      if (this.thirdPartyTask.thirdparty && this.thirdPartyTask.taskId) {
        this.thirdPartyTask.times++
        const resp = await this.checkLoginStatusForThirdParty({
          tid: this.thirdPartyTask.taskId,
          thirdparty: this.thirdPartyTask.thirdparty
        })
        if (resp && resp.status === 'status') {
          if (this.thirdPartyTask.times > 30) {
            this.cleanThirdPartyStatus()
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.loadResumeFailedLater`))
            return
          }
          setTimeout(this.checkThirdPartyStatus, 1000)
        } else if (resp.status === 'failed' && resp.data?.errmsg) {
          if (THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg]) {
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.${THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg].i18nKey}`))
          } else {
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.thirdPartyLoginError`))
          }
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        } else if (resp.status === 'ok' && resp.data) {
          const resumeList = resp.data
          if (resumeList && resumeList.length > 0) {
            this.importResumeSelectFrom.resumeList = resumeList
            const cnUrl = resumeList[0].cn_resume_url
            const enUrl = resumeList[0].en_resume_url
            this.importResumeSelectFrom.selectUrl = cnUrl || enUrl
          }
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        }
      }
    },
    cleanThirdPartyStatus () {
      this.thirdPartyTask.taskId = null
      this.thirdPartyTask.status = ''
      this.thirdPartyTask.times = 0
      this.showThirdPartyLoading = false
      this.canThirdPartyLogin = true
    },
    cleanThirdPartyStatusLoginStatus () {
      this.importResumeSelectFrom = {
        resumeList: [],
        selectUrl: null
      }
    },
    handelThirdpartyChannelChange () {
      this.thirdPartyForm.username = ''
      this.thirdPartyForm.userpwd = ''
    },
    createNewResume () {
      this.$emit('create')
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-candidate {
  max-width: 685px;
  $main-color: #6c6c6c;
  margin-top: 20px;
  position: relative;

  ::v-deep .el-dialog {
    position: relative;
  }

  .header-container {
    font-size: 16px;
    color: #333333;
    margin: 20px 0;
    font-weight: 500;
  }

  .third-party-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    background-color: #f2f8fc;

    .channel-icon {
      color: #0096cc;
      text-align: center;
      cursor: pointer;

      .iconfont {
        font-size: 40px;
      }
    }

    .channel-container {
      margin: 24px 20px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
      position: relative;
      overflow: hidden;

      // &:hover {
      //   .import-container {
      //     transform: translateY(0);
      //   }
      // }

      // &.channel-51job {
      //   background-image: url(~@/assets/image/postingChannel/51job.png);
      // }

      // &.channel-linkedin {
      //   background-image: url(~@/assets/image/postingChannel/linkedin.png);
      // }

      // &.channel-jobstreet {
      //   background-image: url(~@/assets/image/postingChannel/jobstreet.png);
      // }

      // &.channel-facebook {
      //   background-image: url(~@/assets/image/postingChannel/ajinga_cn.png);
      // }

      // .import-container {
      //   position: absolute;
      //   display: flex;
      //   width: 100%;
      //   height: 100%;
      //   transform: translateY(-100%);
      //   transition: transform .3s;
      //   background: rgba($color: #000000, $alpha: 0.7);
      //   top: 0;
      //   left: 0;
      //   cursor: pointer;

      //   .import-btn {
      //     margin: auto;
      //     color: #ffffff;
      //   }
      // }
    }
  }

  .third-party-form-container {
    .form-container {
      width: 80%;
      margin: auto;

      .item-container {
        display: flex;
        align-items: center;
        margin: 20px 0;

        .title {
          width: 30%;
          margin-right: 20px;
          text-align: right;
          color: #000000;
        }

        .content {
          width: 68%;
        }
      }
    }

    ::v-deep .loading-mask {
      position: absolute;
      display: none;
    }
  }

  .split-line {
    display: flex;
    align-items: center;
    margin-top: 26px;

    .line {
      width: 50%;
      border-bottom: 1px solid #dcdfe6;
    }

    .content {
      margin: 0 5px;
      color:#909399;
      font-size: 16px;
    }
  }

  .create-new-resume-container {
    height: 84px;
    text-align: center;
    line-height: 84px;
    background-color: #F2F8FC;
    margin-top: 26px;

    .create-btn {
      width: 226px;
      height: 36px;
      padding: 5px 25px;
      color: #ffffff;
      background-color: #0096cc;
      border: none;
      font-weight: 400;
      border-radius: 0;
      font-size: 14px;
    }
  }

  .select-resume-container {
    .select-resume-item {
      width: 80%;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;

      .title {
        width: 30%;
        margin-right: 30px;
        text-align: right;
        color: #000000;
      }

      .content {
        width: 68%;
      }
    }

    .btn-container {
      width: 80%;
      margin: 50px 10% 0 10%;
    }
  }

  .btn-container {
    display: flex;
    margin-top: 50px;
    justify-content: space-between;

    .action-btn {
      border-radius: 0px;
      font-weight: bold;
      color: #ffffff;
      border: 0;
      background-color: #0096cc;
    }
  }

  &.uploading {
    .upload-dragger {
      cursor: not-allowed;

      * {
        cursor: not-allowed;
      }

      .browser-file {
        .browser-file-label {
          font-weight: 400;
          cursor: not-allowed;
        }
      }
    }
  }

  .container-line {
    margin-bottom: 15px;

    .container-title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #dcdfe6;
      font-size: 18px;
    }

    .container-content {
      text-align: center;
      padding-bottom: 24px;
      background-color: #f2f8fc;

      &.required-class {
        border: 1px dashed #f56c6c;
      }

      .upload-tip {
        color: #606266;
        margin: 0 75px;

        .tip-block {
          font-size: 12px;
          word-break: break-word;
          white-space: normal;
        }
      }
    }
  }

  .upload-dragger {
    width: 500px;
    margin: auto;
    padding: 24px 0 16px 0;
    text-align: center;
    color: $main-color;

    .upload-icon {
      color: #909399;

      i {
        font-size: 40px;
      }

      .blue-icon {
        color: #0096cc;
      }
    }

    .drop-tip {
      margin-top: 12px;
      font-size: 14px;
      color: #606266;
    }

    .or-tip {
      margin-top: 6px;
      font-size: 12px;
      color: #909399;
    }

    .original-file-name {
      margin-top: 20px;
      color: #0096cc;
      font-size: 16px;
    }

    .browser-file {
      margin-top: 10px;
      font-size: 18px;

      .browser-file-label {
        display: inline-block;
        padding: 5px 25px;
        color: #ffffff;
        background-color: #0096cc;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;

        &.reupload {
          background-color: #0096cc;
        }
      }

      &-input {
        display: none;
      }
    }

    .upload-tip {
      margin-top: 15px;
      font-size: 12px;
    }
  }

  .upload-tips {
    width: 500px;
    color: #f56c6c;
  }

  .file-list-container {
    .container-content {
      text-align: left;
      padding: 0 15px;

      .file {
        display: flex;
        padding: 10px 0;
        align-items: center;
        cursor: pointer;

        &:not(:last-child) {
          border-bottom: 1px solid #dcdcdc;
        }

        &:hover {
          .remove-btn {
            transform: rotateZ(180deg);
          }
        }

        .file-name {
          flex: 1;
          color: #000;
        }

        .remove-btn {
          margin-left: auto;
          margin-right: 0;
          line-height: 1;
          font-size: 16px;
          transition: transform .3s;
        }
      }
    }

    .upload-btn-container {
      padding: 10px 0;
      text-align: center;

      .upload-btn {
        padding: 12px 40px;
      }
    }
  }

  .upload-task-container {
    .container-title {
      color: red;
    }

    .upload-task {
      height: 35px;
      margin-bottom: 10px;
      line-height: 35px;
      background: #fff;
      position: relative;

      .upload-progress {
        height: 100%;
        transition: width .3s linear;
        background-color: rgba($color: #daecfe, $alpha: 0.5);
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  .loading {
    position: absolute;
  }
}
</style>
<style lang="scss">
.channel-option-span {
  height: 50px;

  &.jobstreet {
    &::before {
      background-image: url($baseDomain + 'static/image/icon_3rd_logo_jobstreet.png');
    }
  }

  &.channel-51job {
    &::before {
      background-position: 0px -20px;
      background-image: url($baseDomain + 'static/image/icon_3rd_logo_80.png');
    }
  }
}
</style>
